import { TextVariant } from 'blaze-ui/Text/Text'
import Styles from './Title.module.scss'
import { Paragraph } from 'blaze-ui/Paragraph/Paragraph'
import cx from 'classnames'

export const Title = ({ children, variant = 'label' }: { children: string; variant?: TextVariant }) => (
  <div className={cx(Styles.title, Styles[variant])}>
    <Paragraph variant={variant} color="var(--dark-80)" lineClamp={2}>
      {children}
    </Paragraph>
  </div>
)
